import { render, staticRenderFns } from "./Assortments.vue?vue&type=template&id=c639a9f8"
import script from "./Assortments.vue?vue&type=script&lang=js"
export * from "./Assortments.vue?vue&type=script&lang=js"
import style0 from "./Assortments.vue?vue&type=style&index=0&id=c639a9f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports